// SlideIn.js
import React, { useRef } from "react";
import { motion } from "framer-motion";
import slide from "../../keyframes/slide"; 
import {  useInViewOnce } from "../../utils/animationUtils";


const SlideIn = ({
    children,
    direction = "right", 
    delay ,
    className = "",
    ...props
}) => {
    const ref = useRef(null);
    const inView = useInViewOnce(ref);

    const variantsMap = {
        left: slide.slideFromLeft(delay),
        right: slide.slideFromRight(delay),
        up: slide.slideInUp(delay),
        down: slide.slideInDown(delay),
    };

    const variants = variantsMap[direction] || slide.slideFromRight(delay);
    return (
        <motion.div
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"} 
            // exit="exit"
            variants={variants}
            className={className}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default SlideIn;
